'use client';

import dynamic from 'next/dynamic';

// Client wrapper so a server component (the public business page) can use
// this without violating Next.js's "ssr: false only inside a client
// component" rule -- Leaflet itself reads `window` at import time.
const BranchLocationMap = dynamic(() => import('@/components/maps/BranchLocationMap'), { ssr: false });

function timeAgo(iso: string | null | undefined): string {
  if (!iso) return '';
  const minutes = Math.max(0, Math.round((Date.now() - Date.parse(iso)) / 60_000));
  if (minutes < 1) return 'Updated just now';
  if (minutes < 60) return `Updated ${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `Updated ${hours} hr ago`;
  return `Updated ${Math.round(hours / 24)} days ago`;
}

export default function BranchLocationPreview({
  lat,
  lng,
  label,
  updatedAt,
}: {
  lat: number;
  lng: number;
  label?: string | null;
  updatedAt?: string | null;
}) {
  return (
    <div className="space-y-1.5">
      <BranchLocationMap lat={lat} lng={lng} height={180} />
      <div className="flex items-center justify-between text-xs text-[var(--color-text-secondary)]">
        {label ? <span>{label}</span> : null}
        <span>{timeAgo(updatedAt)}</span>
      </div>
    </div>
  );
}
